import en from './en.json'
import it from './it.json'

export const organizationsTranslations = {
	en,
	it
} as const
